import { useState, useCallback } from "react";
import api from "../../services/api";
import { notifyError, notifySucces } from "../../utils/notifications";
import { VipagePayload, ReissuePayload, TransitionBrandCard } from "./types";

export function useVipage() {
  const [loadingVipagem, setLoadingVipagem] = useState<boolean>(false);
  const [loadingCards, setLoadingCards] = useState<boolean>(false);
  const [loadingAction, setLoadingAction] = useState<boolean>(false);

  const endpoint = "vipagem";

  const handleError = useCallback((error: any, fallbackMessage: string) => {
    const errorMessage = 
      error?.response?.data?.message || 
      error?.response?.data?.error || 
      fallbackMessage;
    
    notifyError(errorMessage);
    console.error(`[useVipage] ${fallbackMessage}:`, error);
  }, []);

  const brandCardTransition = useCallback(
    async ({ clientId, productId, cardNumber }: VipagePayload): Promise<boolean> => {
      setLoadingVipagem(true);
      try {
        await api.post(`${endpoint}/bandeirar_conta`, {
          client_id: clientId,
          product_id: productId,
          card_number: cardNumber,
        });

        notifySucces("Transição de bandeira registrada com sucesso!");
        return true;
      } catch (error: any) {
        handleError(error, "Erro ao solicitar transição para bandeira");
        return false;
      } finally {
        setLoadingVipagem(false);
      }
    },
    [handleError]
  );

  const fetchTransitionCards = useCallback(
    async (clientId: number | string): Promise<TransitionBrandCard[] | null> => {
      setLoadingCards(true);
      try {
        // Correção: O Axios GET exige que parâmetros de query fiquem dentro de "params"
        const response = await api.get(`${endpoint}/cartoes_bandeirados_transicao`, { client_id: clientId });

        return response.data;
      } catch (error: any) {
        console.log("Erro ao buscar cartões em transição:", error);
        return null;
      } finally {
        setLoadingCards(false);
      }
    },
    [] // handleError removido do array pois o catch não o utiliza
  );

  const reissueCard = useCallback(
    async ({ clientId, cardId, cardNumber }: ReissuePayload): Promise<boolean> => {
      setLoadingAction(true);
      try {
        await api.post(`${endpoint}/reemitir_cartao_transicao`, {
          client_id: clientId,
          card_id: cardId,
          card_number: cardNumber,
        });

        notifySucces("Cartão reemitido com sucesso!");
        return true;
      } catch (error: any) {
        handleError(error, "Erro ao reemitir cartão.");
        return false;
      } finally {
        setLoadingAction(false);
      }
    },
    [handleError]
  );

  const updateProduct = useCallback(
    async ({ clientId, productId, cardNumber }: VipagePayload): Promise<boolean> => {
      setLoadingAction(true);
      try {
        await api.post(`${endpoint}/alterar_produto_portador`, {
          client_id: clientId,
          product_id: productId,
          card_number: cardNumber,
        });

        notifySucces("Recebimento do cartão confirmado com sucesso!");
        return true;
      } catch (error: any) {
        handleError(error, "Erro ao confirmar recebimento do cartão.");
        return false;
      } finally {
        setLoadingAction(false);
      }
    },
    [handleError]
  );

  return {
    brandCardTransition,
    fetchTransitionCards,
    reissueCard,
    updateProduct,
    loadingVipagem,
    loadingCards,
    loadingAction,
  };
}